import { ErrorOutline, Visibility, VisibilityOff } from "@mui/icons-material";
import { Alert, Button, CircularProgress, InputAdornment, InputBase } from "@mui/material";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const {data} = useParams()
    const [user, setUser] = useState()
    const navigate = useNavigate()


    console.log(data)

    const handleTogglePassword = () => {
      setShowPassword((prev) => !prev);
    };

    function decodeToken(token) {
      try {
        const decoded = jwtDecode(token);
        return decoded;
      } catch (error) {
        console.error('Invalid token:', error);
        return null;
      }
    }

    const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false)
  const [successMsg, setSuccessMsg] = useState(null)

  const resetPassword = async () => {
    setErrorMsg(null);
   
    if(user.password === user.confirm_password){
      setLoader(true);
      try {
        let user_data = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "user/change-password",
          {user_id : user.user_id, newPassword: user.password}
        )

        
        localStorage.setItem('user', JSON.stringify(user_data.data.user) )
        let org_id = user_data?.data?.user?.relatedOrgs?.L[0]?.M?.org_id?.S || null;
        if(!org_id){
          navigate('/create-organization')
        }else{
          let org = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "get-organization",
            { orgId: org_id }
          );
          localStorage.setItem('organization', JSON.stringify(org.data.organization) )

        }
  

      setSuccessMsg('Password Updated Successfully')
      setTimeout(() => {
        setSuccessMsg(null)
        navigate("/dashboard/");
      }, 3000);

      setLoader(false);
    } catch (error) {
      console.log(error)
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrorMsg(error.response.data.message)
      }
      setLoader(false)
    }
    }else{
      setErrorMsg('Password and Confirm must match!')
    }
  };


  useEffect(() => {
      const decodedData = decodeToken(data)
      console.log(decodedData)
      setUser(decodedData)
      
  }, [])
  return (
    <div className=" lg:flex justify-center lg:pt-[140px]">
      <div className=" lg:pt-[20px] pt-[140px] bg-white lg:h-fit h-[100vh] px-8  lg:my-0  lg:w-[30vw]">
        <div className="flex items-center justify-center">
          <img src="/icons/login_img.png" className="w-[50px]" />
        </div>
        <div className="text-center lg:text-[16px] mt-4  font-semibold ">
         Reset Password
        </div>

        {err_msg && (
            <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
              <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
            </div>
          )}


           {successMsg && (
                  <Alert color={'success'} sx={{ my: 2}}  >
                    <div className="text-[14px]">{successMsg}</div>
                  </Alert>
                )}

        <div className="space-y-2 mb-3 mt-4">
          <div className=" lg:text-[14px] text-[13px] ">Password</div>
          <InputBase
              type={showPassword ? "text" : "password"}
              value={user?.password}
              onChange={(e)=> {
                setUser({...user, password: e.target.value})
              }}
              endAdornment={
                <InputAdornment
                  position="end"
                  onClick={handleTogglePassword}
                  className="cursor-pointer"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              }
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: "2px",
                fontSize: "14px",
              }}
            />
        </div>


        <div className="space-y-2 mb-3 mt-4">
          <div className=" lg:text-[14px] text-[13px] ">Confirm</div>
          <InputBase
              type={showPassword ? "text" : "password"}
              value={user?.confirm_password}
              onChange={(e)=> {
                setUser({...user, confirm_password: e.target.value})
              }}
              endAdornment={
                <InputAdornment
                  position="end"
                  onClick={handleTogglePassword}
                  className="cursor-pointer"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </InputAdornment>
              }
              sx={{
                bgcolor: "#F7F7F8",
                width: "100%",
                px: 2,
                py: "2px",
                fontSize: "14px",
              }}
            />
        </div>

      

     

        <div className="flex justify-center pt-6 pb-4 space-x-2">
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: "6px",
              px: "40px",
              borderRadius: "7px",
              fontSize: { lg: "14px", xs: "13px" },
              width: "100%",
            }}
            onClick={resetPassword}
          >
            {loader? (
                          <CircularProgress
                            size={"1.3rem"}
                            sx={{ color: "white" }}
                          />
                        ) : (
                          "  Reset Your Password"
                        )}
         
          </Button>
        </div>

       
      </div>
    </div>
  );
};

export default ResetPassword;
